import Image from 'next/image';

import { IResolvedSteppers } from '@/src/utils/collections/steppers.mapper';
import { SteppersItem } from '@/src/components/steppers/StepperLeftPanel/StepperLeftPanelItem';

export const StepperLeftPanel = ({
  title,
  subtitle,
  items,
  layout,
  showStepperLine,
}: IResolvedSteppers) => {
  return (
    <div
      className={`mx-auto max-w-1200 justify-between space-y-8 px-4 py-20 lg:flex lg:space-y-0`}
    >
      <div className={'flex flex-col lg:max-w-xl'}>
        <div className={'mb-4 text-4xl font-semibold'}>{title}</div>
        <div className={'mb-4 flex-1 text-lg text-gray'}>{subtitle}</div>
        {layout.data?.image && (
          <div className={'mt-10 hidden justify-center md:block'}>
            <div className={'relative inline-block'}>
              <Image
                src={layout.data.image.image}
                className={'rounded-xl'}
                alt={layout.data.image.alt || ''}
                width={490}
                height={200}
              />

              {layout.data.card?.imageCard && (
                <div
                  className={
                    'absolute -right-10 bottom-3 flex items-center gap-7 rounded-2xl bg-white p-4 shadow'
                  }
                >
                  <Image
                    src={layout.data.card?.imageCard.image}
                    alt={layout.data.card?.imageCard.alt || ''}
                    width={174}
                    height={54}
                  />
                  <div className={'font-semibold'}>
                    {layout.data.card?.text}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <div className={'flex flex-col gap-8'}>
        {items.map((item, index) => (
          <SteppersItem
            key={item.title + '_' + index}
            {...item}
            last={index === items.length - 1}
            showStepperLine={showStepperLine}
          />
        ))}
      </div>
      {layout.data?.image && (
        <div className={'block justify-center md:hidden'}>
          <div className={'relative inline-block'}>
            <Image
              placeholder={'blur'}
              blurDataURL={'/static/images/placeholder.webp'}
              src={layout.data.image.image}
              alt={layout.data.image.alt || ''}
              className={'rounded-lg'}
              width={490}
              height={318}
            />
            {layout.data?.card?.imageCard && (
              <div
                className={
                  'absolute bottom-0 right-1/2 flex w-[310px] max-w-full translate-x-1/2 translate-y-1/2 items-center justify-between gap-7 rounded-2xl bg-white p-4 shadow'
                }
              >
                <Image
                  src={layout.data.card?.imageCard.image}
                  alt={layout.data.card?.imageCard.alt || ''}
                  width={174}
                  height={54}
                  className="shrink-0"
                />
                <div className="shrink-0 font-semibold">
                  {layout.data.card?.text}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
